import camelCase from "lodash/camelCase";

export const toCamelCase = (array: string[]) => {
  return camelCase(array.join(" "));
};

export const censorEmail = (email: string) => {
  const censorWord = function(word: string) {
    return word[0] + "*".repeat(word.length - 2) + word.slice(-1);
  };
  const emailParts = email.split("@");
  return censorWord(emailParts[0]) + "@" + censorWord(emailParts[1]);
};

export const censorPhone = (phone: string) => {
  return (
    phone.slice(0, 4) +
    "*".repeat(phone.length - 4) +
    phone.slice(phone.length - 4)
  );
};

interface PluralizeOptions {
  one: string;
  other: string;
}
export const pluralize = (count: number, options: PluralizeOptions) => {
  if (count === 1) {
    return options["one"];
  }
  return options["other"];
};

export const humanJoin = (array: string[]) => {
  if (array.length === 0) {
    return "";
  } else if (array.length === 1) {
    return array[0];
  } else if (array.length === 2) {
    return array.join(" and ");
  } else {
  }
  return `${array.slice(0, -2).join(", ")}, ${array.slice(-2).join(" and ")}`;
};
